import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export async function apiLogin(email, password) {
  const { data } = await api.post("/auth/login", { email, password });
  return data;
}

export async function apiMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function apiLogout() {
  await api.post("/auth/logout");
}

export async function apiChangePassword(current_password, new_password) {
  const { data } = await api.post("/auth/change-password", {
    current_password,
    new_password,
  });
  return data;
}

export async function apiGetState() {
  const { data } = await api.get("/state");
  return data;
}

export async function apiSetStateKey(key, value) {
  await api.put(`/state/${key}`, { value });
}

export async function apiResetState() {
  await api.post("/state/reset");
}
